/* Custom JavaScript. (Theme hook documentation comment removed; see Shopify theme docs for variant:changed / product:added / cart:refresh events.) */

/* ===== Minimum order value (INR 200) =====
   Items priced under the threshold can only be bought if the cart total reaches it.
   Carts that already include other items bringing the total to 200+ have no minimum. */
(function () {
  var MIN = 20000; // in paise (INR 200)
  var okFlag = false;
  function rs(p) { return 'Rs. ' + (p / 100).toLocaleString('en-IN', {maximumFractionDigits: 2}); }
  function toast(msg) {
    var t = document.getElementById('moq-toast');
    if (!t) {
      t = document.createElement('div'); t.id = 'moq-toast';
      t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);max-width:92%;background:#b3261e;color:#fff;padding:12px 18px;border-radius:6px;z-index:2147483647;font-size:15px;line-height:1.4;box-shadow:0 4px 14px rgba(0,0,0,.3);text-align:center';
      document.body.appendChild(t);
    }
    t.textContent = msg; t.style.display = 'block';
    clearTimeout(t._h); t._h = setTimeout(function () { t.style.display = 'none'; }, 6000);
  }
  function getJSON(u) { return fetch(u, {credentials: 'same-origin'}).then(function (r) { return r.json(); }); }

  // ---- Block checkout from cart / mini-cart when total < MIN ----
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href^="/checkout"], a[href*="/checkout?"]');
    if (!el || okFlag) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    getJSON('/cart.js').then(function (cart) {
      if (cart.total_price >= MIN) { okFlag = true; el.click(); setTimeout(function () { okFlag = false; }, 1500); return; }
      var need = MIN - cart.total_price;
      toast('Minimum order value is ' + rs(MIN) + '. Your cart is ' + rs(cart.total_price) + ' - add ' + rs(need) + ' more (more pieces or other items) to checkout.');
    }).catch(function () { okFlag = true; el.click(); });
  }, true);

  // ---- Block "Buy it now" / dynamic checkout buttons when item value < MIN ----
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.shopify-payment-button button, .shopify-payment-button__button, [data-shopify="payment-button"] button');
    if (!b || okFlag) return;
    var form = b.closest('form[action*="/cart/add"]');
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!form || !m) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    getJSON('/products/' + m[1] + '.js').then(function (p) {
      var idEl = form.querySelector('[name="id"]'); var qEl = form.querySelector('[name="quantity"]');
      var id = idEl ? parseInt(idEl.value, 10) : 0; var qty = qEl ? parseInt(qEl.value, 10) || 1 : 1;
      var v = p.variants.filter(function (x) { return x.id === id; })[0] || p.variants[0];
      if (v.price * qty >= MIN) { okFlag = true; b.click(); setTimeout(function () { okFlag = false; }, 1500); return; }
      var n = Math.ceil(MIN / v.price);
      toast('Minimum order value is ' + rs(MIN) + '. Order at least ' + n + ' pcs of this item, or use Add to cart with other items.');
    }).catch(function () { okFlag = true; b.click(); });
  }, true);

  // ---- Product page note ----
  function productNote() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/); if (!m) return;
    var form = document.querySelector('form[action*="/cart/add"]'); if (!form) return;
    getJSON('/products/' + m[1] + '.js').then(function (p) {
      var idEl = form.querySelector('[name="id"]'); var id = idEl ? parseInt(idEl.value, 10) : 0;
      var v = p.variants.filter(function (x) { return x.id === id; })[0] || p.variants[0];
      var n = document.getElementById('moq-note');
      if (v.price >= MIN || v.price <= 0) { if (n) n.style.display = 'none'; return; }
      if (!n) {
        n = document.createElement('div'); n.id = 'moq-note';
        n.style.cssText = 'margin:10px 0;padding:10px 12px;border-left:4px solid #b3261e;background:#fdf1f0;font-size:14px;line-height:1.4';
        form.parentNode.insertBefore(n, form);
      }
      var q = Math.ceil(MIN / v.price);
      n.style.display = 'block';
      n.innerHTML = '<strong>Minimum order ' + rs(MIN) + '.</strong> Buy at least <strong>' + q + ' pcs</strong> of this item (' + rs(q * v.price) + '), or add other items so your cart total is ' + rs(MIN) + ' or more. No minimum quantity once your cart reaches ' + rs(MIN) + '.';
    }).catch(function () {});
  }
  if (document.readyState !== 'loading') productNote(); else document.addEventListener('DOMContentLoaded', productNote);
  document.addEventListener('variant:changed', function () { setTimeout(productNote, 50); });
})();
